<template>
  <div class="photo-album">

    <div class="container">

      <div class="headline">
        <h1>{{$t("talentDevelopment.employeeCare.headlineTitle")}}</h1>
        <p>{{$t("talentDevelopment.employeeCare.headlineP")}}</p>
      </div>

      <el-row :gutter="30">
          <el-col :span="6" v-for="(item,index) in employeeLists" :key="index" >
            <div class="pic-wrap" @click="handlePictureCardPreview(item.picturePath)">
              <div class="pic" :style="{height:imgH+'px'}" ref="pic">
                  <img :src="item.picturePath" />
              </div>
              <div class="des-row">
                  <p>{{item.createTime.slice(0,10)}}</p>
                  <p>{{item.picName}}</p>
              </div>
            </div>
          </el-col>
      </el-row>

      <!-- <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="size"
        @pagination="getList"
      /> -->

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
          
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {getpiclist} from "../../api/about"
export default {
  name: "DulkTrade",
  computed:{
    ...mapGetters(['language'])
  },
  data() {
    return {
      imgH:"0",
      employeeLists:[],
      total:0,
      page:0,
      size:10,
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  mounted() {

    var options = { live: false };
    new this.$wow.WOW(options).init();
    
    // 3团队风采 2公司奖章 1员工关爱
    getpiclist(this.language,"1").then(res=>{
      this.employeeLists = res.data[0].picList;
      this.$nextTick(()=>{
        this.imgH=this.$refs.pic[0].offsetWidth;
      })
    });
  },
  methods: {
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

  }
};
</script>

<style scoped lang="scss">
.photo-album {
  .pic-wrap{
    // transition: all 0.4s #0052ac;
    margin-bottom:20px;
    &:hover{
      color:#0052ac;
      cursor: pointer;
      box-shadow: 0 0 3px ;
      // img{
      //   transform: scale(1.1);
      // }
    }
    .pic{
        background: #F4F4F4;
        border-radius: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        position: relative;
        img{
          object-fit: cover;
        }
    }
    .des-row{
        padding:15px;
        p{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
    }
  }
}
</style>
